<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show v-if="relations.products"
                :id="id"
                model-def="assets"
                model-class="asset"
                :models="models"
                :infos="infos"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">
                <template v-slot:relations>
                    <v-row class="ma-0" v-if="$store.getters.checkModelPermissions('credential')">
                        <belongstomany-show 
                            class="pb-4"
                            :collection="relations.credentials.collection"
                            :headers="relations.credentials.info.fieldDefs"
                            title="Credenziali"
                            downloadCSV>
                        </belongstomany-show>
                    </v-row>
                    <v-row class="ma-0">
                        <belongstomany-show 
                            class="pb-4"
                            :collection="relations.products.collection"
                            :headers="relations.products.info.fieldDefs"
                            title="Prodotti"
                            downloadCSV>
                            <template v-slot:table-footer v-if="!totalsHidden">
                                <v-container class="py-3 px-3">
                                    <totals-cards
                                        :totals-fields="totalsFields"
                                        :data="totalsData"
                                        :col-sizes="{ lg: 3, md: 4, sm: 6 }"
                                    ></totals-cards>
                                </v-container>
                            </template>
                        </belongstomany-show>
                    </v-row>
                </template>
            </show>

        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'
    import TotalsCards from '@/components/common/TotalsCards'

    export default {
        name: 'asset',
        components: {
			BelongstomanyShow,
			TotalsCards
        },
        
        props: {
            id: Number,
        },

        data() {
            return {
				infos: {},
				models: {},
				relations: {},		
            }
        },

        computed: {
            totalsFields() {
                return this.infos.assets?.totals_config?.fields || null
            },
            totalsHidden() {
                return this.infos.assets?.totals_config?.hidden || false
            },
            totalsData() {
                const products = this.relations.products.collection
                return {
                    products_count: products.length,
                    total_price: products.reduce((acc, product) => acc + (product.price * product.quantity), 0),
                    total_cost: products.reduce((acc, product) => acc + (product.purchase_price * product.quantity), 0)
                }
            }
        },

        methods: {
            initialization() {
                this.axios.get('assets/' + this.id).then(response => {
                    // get body data
                    this.$set(this, 'models', response.data.models)
                    this.$set(this, 'infos', response.data.infos)
                    this.$set(this, 'relations', response.data.relations)
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })
            }
        },

        created() {
            this.initialization()
        },
      
      

    }
</script>